<template>
  <div>
    <h1 class="page-title">Dashboard</h1>

    <SkeletonLoader v-if="store.loading" variant="stat-card" :count="4" />

    <div class="stats-grid" v-else>
      <div class="stat-card card">
        <div class="stat-icon stat-total">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M16 17v2H2v-2s0-4 7-4s7 4 7 4m-3.5-9.5A3.5 3.5 0 1 0 9 11a3.5 3.5 0 0 0 3.5-3.5m3.44 5.5A5.32 5.32 0 0 1 18 17v2h4v-2s0-3.63-6.06-4M15 4a3.39 3.39 0 0 0-1.93.59a5 5 0 0 1 0 5.82A3.39 3.39 0 0 0 15 11a3.5 3.5 0 0 0 0-7Z"/></svg>
        </div>
        <div class="stat-info">
          <span class="stat-number">{{ store.totalCount }}</span>
          <span class="stat-label">Total Inscritos</span>
        </div>
      </div>

      <div class="stat-card card">
        <div class="stat-icon stat-confirmed">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="m10.6 16.6l7.05-7.05l-1.4-1.4l-5.65 5.65l-2.85-2.85l-1.4 1.4l4.25 4.25ZM12 22q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22Z"/></svg>
        </div>
        <div class="stat-info">
          <span class="stat-number">{{ store.confirmedCount }}</span>
          <span class="stat-label">Confirmados</span>
        </div>
      </div>

      <div class="stat-card card">
        <div class="stat-icon stat-pending">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m.5-13H11v6l5.2 3.2l.8-1.3l-4.5-2.7V7Z"/></svg>
        </div>
        <div class="stat-info">
          <span class="stat-number">{{ store.pendingCount }}</span>
          <span class="stat-label">Pendentes</span>
        </div>
      </div>

      <div class="stat-card card">
        <div class="stat-icon stat-percent">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-7 2h1.5v3l2-3h1.7l-2 3l2 3h-1.7l-2-3v3H12V5zM7 7.25h2.5V6.5H7V5h4v3.75H8.5v.75H11V11H7V7.25zM19 19H5L19 5v14z"/></svg>
        </div>
        <div class="stat-info">
          <span class="stat-number">{{ store.checkInPercentage }}%</span>
          <span class="stat-label">Check-in</span>
        </div>
      </div>
    </div>

    <!-- Ultimos confirmados -->
    <div class="recent-section" v-if="recentCheckins.length > 0">
      <h2 class="section-title">Ultimos Check-ins</h2>
      <div class="recent-list card">
        <div class="recent-item" v-for="item in recentCheckins" :key="item.id">
          <span class="recent-name">{{ item.name }}</span>
          <span class="recent-leader">{{ item.leader }}</span>
          <StatusBadge status="confirmed" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useParticipantsStore } from '../stores/participants'
import SkeletonLoader from '../components/ui/SkeletonLoader.vue'
import StatusBadge from '../components/ui/StatusBadge.vue'

export default {
  name: 'DashboardPage',
  components: { SkeletonLoader, StatusBadge },
  computed: {
    store() { return useParticipantsStore() },
    recentCheckins() {
      return this.store.confirmed.slice(0, 5)
    }
  }
}
</script>

<style scoped>
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: var(--spacing-base);
  margin-bottom: var(--spacing-xl);
}
.stat-card {
  display: flex;
  align-items: center;
  gap: var(--spacing-base);
  padding: var(--spacing-base) var(--spacing-lg);
}
.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: var(--radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.stat-total { background: rgba(51,102,204,0.1); color: var(--color-accent); }
.stat-confirmed { background: rgba(46,204,113,0.1); color: var(--color-success); }
.stat-pending { background: rgba(241,196,15,0.15); color: #f39c12; }
.stat-percent { background: rgba(155,89,182,0.1); color: #9b59b6; }
.stat-info {
  display: flex;
  flex-direction: column;
}
.stat-number {
  font-size: var(--text-3xl);
  font-weight: 700;
  color: var(--color-text-primary);
  line-height: 1;
}
.stat-label {
  font-size: var(--text-sm);
  color: var(--color-text-muted);
  margin-top: var(--spacing-xs);
}
.section-title {
  font-size: var(--text-lg);
  font-weight: 600;
  color: var(--color-text-primary);
  margin-bottom: var(--spacing-base);
}
.recent-list {
  padding: 0;
}
.recent-item {
  display: flex;
  align-items: center;
  gap: var(--spacing-base);
  padding: 14px var(--spacing-lg);
  border-bottom: 1px solid var(--color-bg-separator);
}
.recent-item:last-child {
  border-bottom: none;
}
.recent-name {
  font-weight: 600;
  color: var(--color-text-primary);
  flex: 1;
}
.recent-leader {
  font-size: var(--text-sm);
  color: var(--color-text-muted);
}
</style>
